import {component} from '@reduct/component';
import {
    Chart,
    LineElement,
    PointElement,
    LineController,
    CategoryScale,
    LinearScale,
    Legend,
    Title,
    Tooltip
} from 'chart.js';
import propTypes from "@reduct/nitpick";

Chart.register(
    LineElement,
    LineController,
    CategoryScale,
    LinearScale,
    PointElement,
    Legend,
    Title,
    Tooltip
);

@component({
    config: propTypes.object.isRequired,
    imagePath: propTypes.string.isRequired
})
export default class ChartComponent {
    constructor() {
        let pointStyle = [];

        this.props.config.yPoints.forEach(point => {
            let pointImage = new Image();
            pointImage.src = this.props.imagePath + point + '.png';

            pointStyle.push(pointImage);
        });

        let config = {
            type: 'line',
            data: {
                labels: this.props.config.xData,
                datasets: [
                    {
                        label: this.props.config.yTitle,
                        data: this.props.config.yData,
                        backgroundColor: 'blue',
                        borderColor: '#2d78f7',
                        borderWidth: 2,
                        pointStyle: pointStyle
                    }
                ]
            },
            options: {
                layout: {
                    padding: 15
                },
                maintainAspectRatio: false,
                scales: {
                    x: {
                        grid: {
                            color: 'rgba(45, 120, 247, 0.2)',
                            display: false
                        },
                        ticks: {
                            color: 'rgba(45, 120, 247, 0.6)',
                            font: {
                                size: 14
                            }
                        },
                        title: {
                            display: true,
                            text: this.props.config.xTitle,
                            color: '#2d78f7',
                            font: {
                                family: 'Lato',
                                size: 20,
                                lineHeight: 1.2,
                            },
                            padding: {top: 10, left: 0, right: 0, bottom: 0}
                        }
                    },
                    y: {
                        offset: true,
                        grid: {
                            color: 'rgba(45, 120, 247, 0.2)',
                            display: false
                        },
                        ticks: {
                            color: 'rgba(45, 120, 247, 0.6)',
                            font: {
                                size: 14
                            }
                        },
                        title: {
                            display: true,
                            text: this.props.config.yTitle,
                            color: '#2d78f7',
                            font: {
                                family: 'Lato',
                                size: 25,
                            },
                            backdropPadding: 0,
                            padding: {top: 0, left: 0, right: 0, bottom: 5}
                        }
                    },
                },
                plugins: {
                    legend: {
                        labels: false
                    },
                    tooltip: {
                        displayColors: false,
                        borderColor: 'rgb(236, 243, 250, 1)',
                        borderWidth: 1,
                        bodySpacing: 2,
                        bodyFont: {
                            family: 'Lato',
                            size: 14,
                        },
                        backgroundColor: 'rgba(45, 120, 247, 1)',
                        bodyColor: 'rgba(255, 255, 255, 1)',
                        callbacks: {
                            title: () => {
                                return false;
                            }
                        }
                    }
                },
                animation: {
                    numbers: {duration: 2000},
                    delay: 100
                }
            },
        };

        new Chart(this.el.querySelector('canvas'), config);
    }
}
